<script setup>

</script>

<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6h16M4 12h16M4 18h16" stroke="#333" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>

<style scoped>
svg {
  display: block;
  width: 28px;
  height: 28px;
}
</style>